import {Button, styled} from '@mui/material';

const StyledButton = styled(Button)`
	padding: 0;
	text-decoration: underline;

	&:hover {
		text-decoration: underline;
	}
`;

export {StyledButton};
